import { defineComponent as _defineComponent } from 'vue'
import { CoordinateType } from '@/hook'
import { reactive, watch, watchEffect } from 'vue'
import { coordTypes } from './constant'
import Slot from '@/main/component/slot.vue'
import { localGetFactory, localSetFactory } from '@/utils/store'
import { LocalCoord } from '@/hook/useTransform'
import { os } from '@/utils'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: { type: String, required: true },
    type: { type: null, required: true },
    hideTitle: { type: Boolean, required: false },
    disabled: { type: Number, required: false },
    disShow: { type: Array, required: false }
  },
  emits: ["update:modelValue", "update:type"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;

const selects = reactive({
  // [CoordinateType.GIS]: cacheSelects[CoordinateType.GIS],
  [CoordinateType.PRO]: null
})

watch(
  () => coordTypes[CoordinateType.PRO].options,
  () => {
    selects[CoordinateType.PRO] =
      coordTypes[CoordinateType.PRO].options.value[0].value
  },
  {
    immediate: true
  }
)
watch(
  () => coordTypes[CoordinateType.GIS].options,
  () => {
    selects[CoordinateType.GIS] =
      coordTypes[CoordinateType.GIS].options.value[0].value
  },
  {
    immediate: true
  }
)
watchEffect(() => {
  const otherSelect = selects[props.type]
  if (Object.keys(selects).includes(props.type.toString())) {
    emit('update:modelValue', otherSelect)
  }
})





const __returned__ = { selects, props, emit, get coordTypes() { return coordTypes }, Slot }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})